import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import { 
  SUPPLIER_DETAIL,
  SUPPLIER_SEARCH,
  SUPPLIER_ADD,
  SUPPLIER_SEARCH_SUPPLIER_STATE_LIST,
  SUPPLIER_SEARCH_SUPPLIER_LIST,
  SUPPLIER_LIST,
} from '../actions';

import {
  SupplierDetailSuccess,
  SupplierDetailError,
  SupplierSearchSuccess,
  SupplierSearchError,
  SupplierAddSuccess,
  SupplierAddError,
  SupplierSearchSupplierStateListSuccess,
  SupplierSearchSupplierStateListError,
  SupplierSearchSupplierListSuccess,
  SupplierSearchSupplierListError,
  SupplierListSuccess,
  SupplierListError,
} from '../actions';

export function* watchSupplierDetail() {
  yield takeEvery(SUPPLIER_DETAIL, onSupplierDetail);
}

export function* watchSupplierSearch() {
  yield takeEvery(SUPPLIER_SEARCH, onSupplierSearch);
}

export function* watchSupplierAdd() {
  yield takeEvery(SUPPLIER_ADD, onSupplierAdd);
}

export function* watchSupplierSearchSupplierStateList() {
  yield takeEvery(SUPPLIER_SEARCH_SUPPLIER_STATE_LIST, onSupplierSearchSupplierStateList);
}

export function* watchSupplierSearchSupplierList() {
  yield takeEvery(SUPPLIER_SEARCH_SUPPLIER_LIST, onSupplierSearchSupplierList);
}

export function* watchSupplierList() {
  yield takeEvery(SUPPLIER_LIST, onSupplierList);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onSupplierDetailAsync  = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/get', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onSupplierSearchAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/search', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

const onSupplierAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

const onSupplierSearchSupplierStateListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/supplier_state', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSupplierSearchSupplierListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/supplier', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSupplierListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onSupplierSearch(data) {
  try {
    const response = yield call(onSupplierSearchAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(SupplierSearchSuccess(response.data.data));
  } catch (error) {
    console.log('catch error', error)
    yield put(SupplierSearchError(error));
  }
}

function* onSupplierAdd(data) {
  try {
    const response = yield call(onSupplierAddAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(SupplierAddSuccess(response.data.data));
  } catch (error) {
    console.log('catch error', error)
    yield put(SupplierAddError(error));
  }
}

function* onSupplierDetail(data) {
  try {
    const response = yield call(onSupplierDetailAsync, data);
    yield put(SupplierDetailSuccess(response.data.data));
  } catch (error) {
    yield put(SupplierDetailError(error));
  }
}

function* onSupplierSearchSupplierStateList(data) {
  try {
    const response = yield call(onSupplierSearchSupplierStateListAsync, data);
    yield put(SupplierSearchSupplierStateListSuccess(response.data));
  } catch (error) {
    yield put(SupplierSearchSupplierStateListError(error));
  }
}

function* onSupplierSearchSupplierList(data) {
  try {
    const response = yield call(onSupplierSearchSupplierListAsync, data);
    yield put(SupplierSearchSupplierListSuccess(response.data));
  } catch (error) {
    yield put(SupplierSearchSupplierListError(error));
  }
}

function* onSupplierList(data) {
  try {
    const response = yield call(onSupplierListAsync, data.payload);
    yield put(SupplierListSuccess(response.data));
  } catch (error) {
    yield put(SupplierListError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchSupplierDetail),
    fork(watchSupplierSearch),
    fork(watchSupplierSearchSupplierStateList),
    fork(watchSupplierSearchSupplierList),
    fork(watchSupplierList),
    fork(watchSupplierAdd),
  ]);
}